import React from 'react';

import Base from './Base.jsx';

import NFTHistoricalRevenue from '../Components/NFTHistoricalRevenue/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-nft-historical-revenue';
  }

  renderElement(element) {
    var id = element.dataset.id;
    if (id) {
      id = parseInt(id);
      if (isNaN(id)) {
        id = undefined;
      }
    }

    return (
      <NFTHistoricalRevenue id={id} />
    );
  }
}


export default EntryPoint;

